// common site settings
exports.COUNTDOWN_FINAL_DATE = "Nov 25, 2023 05:28:00";
exports.DEFAULT_STATISTIC_SLIDE_DURATION_SECONDS = 6;
exports.DEFAULT_MAX_PERIOD_STATION_INACTIVITY_SECONDS = 30;
exports.PATH_SCREENSHOT_STORAGE_URL = "/assets/screenshots/";
// exports.PATH_SCREENSHOT_STORAGE_URL = '/assets_dev/screenshots/';
exports.PATH_SCREENSHOT_STORAGE =
  __dirname + "/../../.." + exports.PATH_SCREENSHOT_STORAGE_URL;
exports.MAIL_SCREENSHOT_FROM = "snapshotsender@cms.campusnyland.modulez.no";
exports.MAIL_SCREENSHOT_TO = "alex@modulez.no";
exports.MAIL_SCREENSHOT_SUBJECT = "Bane Nor Nyland: snapshots ";



//////////////////
// WEBPACK FOOTER
// ../cms/server/app/abstract/constants_project.js
// module id = djoi
// module chunks = 1